import { render, staticRenderFns } from "./MusicPause.vue?vue&type=template&id=10280095&scoped=true&"
import script from "./MusicPause.vue?vue&type=script&lang=js&"
export * from "./MusicPause.vue?vue&type=script&lang=js&"
import style0 from "./MusicPause.vue?vue&type=style&index=0&id=10280095&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10280095",
  null
  
)

export default component.exports